// @flow

import styled, { css } from "styled-components";
import ButtonDefault from "../../_atom/Buttons/default";

import buildColor from "../../_static/ColorPalette";
import { fontMedium } from "../../_static/Typography";
import {
  easeInOut,
  cubic,
  generateTransition
} from "../../_static/Transitions";

export const WagerTypeContainer = styled.section`
  position: sticky;
  top: ${(props) => `${props.fixedOffset}px`};
  z-index: 20;
  height: 48px;
  min-height: 48px;
  background-color: ${buildColor("white", "100")};
  overflow: hidden;
  display: flex;
`;

export const SelectorWrapper = styled.ul.attrs({
  "data-qa-label": "wagerTypeSelector"
})`
  position: relative;
  display: flex;
  padding: 0;
  list-style: none;
  flex-wrap: nowrap;
  flex: 0 0 100%;
  overflow-x: auto;
  overflow-y: hidden;
  left: 0;
  right: 0;
  background-color: ${buildColor("white", "0")};
  box-shadow: 0 -1px 0 0 ${buildColor("grey", "300")},
    inset 0 -1px 0 0 ${buildColor("grey", "300")};
  z-index: ${(props) => (props.isVisible ? 1 : 0)};
  will-change: opacity;
  transition: ${generateTransition(easeInOut, "opacity")};
  opacity: ${(props) => (props.isVisible ? 1 : 0)};
  ${(props) =>
    props.device === "tablet" &&
    css`
      border-right: 1px solid ${buildColor("grey", "300")};
      border-left: 1px solid ${buildColor("grey", "300")};
    `};
`;

export const WagerTypeButton = styled(ButtonDefault)`
  white-space: nowrap;
  min-width: 48px;
  height: 48px;
  padding: 0 8px;
  text-transform: uppercase;
  background-color: ${buildColor("white", "0")};
  font-size: 14px;
  font-family: ${fontMedium};
  will-change: color;
  font-weight: normal;
  transition: ${generateTransition(easeInOut, "color")};
  color: ${(props) =>
    props.selected
      ? buildColor("blue_accent", "600")
      : buildColor("grey", "900")};
  position: relative;

  &:active {
    background-color: ${buildColor("blue", "000")};
    box-shadow: 0 -1px 0 0 ${buildColor("grey", "300")},
      inset 0 -1px 0 0 ${buildColor("grey", "300")};
  }

  &::after {
    content: "";
    display: block;
    position: absolute;
    left: 0;
    right: 0;
    bottom: ${(props) => (props.selected ? "0" : "-3px")};
    height: 3px;
    will-change: bottom;
    transition: ${generateTransition(easeInOut, "bottom")};
    background-color: ${buildColor("blue_accent", "600")};
  }
`;

export const OptionsWrapper = styled.div.attrs({
  "data-qa-label": "subWagerTypeSelector"
})`
  display: flex;
  left: 0;
  right: 0;
  background-color: ${buildColor("white", "0")};
  box-shadow: 0 -1px 0 0 ${buildColor("grey", "300")},
    inset 0 -1px 0 0 ${buildColor("grey", "300")};
  position: absolute;
  z-index: ${(props) => (props.isVisible ? 1 : 0)};

  & > :first-child {
    flex: 0 0 auto;
  }
`;

export const SubSelectorWrapper = styled.div`
  background-color: ${buildColor("white", "0")};
  box-shadow: 0 -1px 0 0 ${buildColor("grey", "300")},
    inset 0 -1px 0 0 ${buildColor("grey", "300")};
  will-change: transform, opacity;
  overflow-x: auto;
  overflow-y: hidden;
  flex-grow: 1;
  transition: ${generateTransition(cubic, "transform")},
    ${generateTransition(easeInOut, "opacity")};
  ${(props) =>
    props.isVisible
      ? css`
          opacity: 1;
          transform: translate(0, 0);
          transition-delay: 200ms;
        `
      : css`
          opacity: 0;
          transform: translate(100%, 0);
        `};
`;

export const SubSelectorList = styled.ul.attrs({
  "data-qa-label": "subWagerTypeSelectorList"
})`
  padding: 0;
  list-style: none;
  display: flex;
  flex: 1 0 0;
  flex-wrap: nowrap;
  overflow-x: auto;
  overflow-y: hidden;
`;

export const BackButton = styled(ButtonDefault)`
  height: 48px;
  padding: 0 8px;
  background-color: ${buildColor("white", "0")};
  display: flex;
  align-items: center;
  border-right: 1px solid ${buildColor("grey", "300")};
  will-change: transform, opacity;
  transition: ${generateTransition(cubic, "transform")},
    ${generateTransition(easeInOut, "opacity")};
  ${(props) =>
    props.isVisible
      ? css`
          opacity: 1;
          transform: translate(0, 0);
          transition-delay: 200ms;
        `
      : css`
          opacity: 0;
          transform: translate(-100%, 0);
        `};

  & > :first-child {
    margin: 16px 0;
  }
`;

export const TextContainer = styled.span`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 48px;
  padding: 10px 0;
  margin-left: 8px;
  text-transform: uppercase;
  text-align: left;
  font-size: 14px;
  font-family: ${fontMedium};
  color: ${buildColor("grey", "900")};

  & > :first-child {
    display: block;
    color: ${buildColor("grey", "700")};
    font-size: 10px;
  }
`;
